<template>
  <div class="home">
    <Fquestion />
    <Qclass />
    <Sservice />
  </div>
</template>

<style lang="scss" scoped>
  @import './style.scss';
</style>

<script>
import Qclass from './components/Qclass';
import Sservice from './components/Sservice';
import Fquestion from './components/Fquestion';

export default {
  name: 'Home',
  components: {
    Qclass,
    Sservice,
    Fquestion,
  },
};
</script>
